import _find from 'lodash/find'

export const getCountryDialCode = (country: string) =>
  _find(countryCodes, (item) => item.code.toUpperCase() === country.toUpperCase())
    ?.dial_code || '+1'

export const countryCodes = [
  {
    name: {
      en: 'Afghanistan',
      ru: 'Афганистан',
      pl: 'Afganistan',
      ua: 'Афганістан',
      cz: 'Afghánistán',
      by: '',
      pt: 'Afeganistão',
    },
    dial_code: '+93',
    code: 'AF',
    flag: '🇦🇫',
  },
  {
    name: {
      en: 'Albania',
      ru: 'Албания',
      pl: 'Albania',
      ua: 'Албанія',
      cz: 'Albánie',
      by: '',
      pt: 'Albânia',
    },
    dial_code: '+355',
    code: 'AL',
    flag: '🇦🇱',
  },
  {
    name: {
      en: 'Algeria',
      ru: 'Алжир',
      pl: 'Algieria',
      ua: 'Алжир',
      cz: 'Alžírsko',
      by: '',
      pt: 'Argélia',
    },
    dial_code: '+213',
    code: 'DZ',
    flag: '🇩🇿',
  },
  {
    name: {
      en: 'American Samoa',
      ru: 'Американское Самоа',
      pl: 'Samoa Amerykańskie',
      ua: 'Американське Самоа',
      cz: 'Americká Samoa',
      by: '',
      pt: 'Samoa',
    },
    dial_code: '+1684',
    code: 'AS',
    flag: '🇦🇸',
  },
  {
    name: {
      en: 'Andorra',
      ru: 'Андорра',
      pl: 'Andora',
      ua: 'Андорра',
      cz: 'Andorra',
      by: '',
      pt: 'Andorra',
    },
    dial_code: '+376',
    code: 'AD',
    flag: '🇦🇩',
  },
  {
    name: {
      en: 'Angola',
      ru: 'Ангола',
      pl: 'Angola',
      ua: 'Ангола',
      cz: 'Angola',
      by: '',
      pt: 'Angola',
    },
    dial_code: '+244',
    code: 'AO',
    flag: '🇦🇴',
  },
  {
    name: {
      en: 'Anguilla',
      ru: 'Ангилья',
      pl: 'Anguilla',
      ua: 'Ангілья',
      cz: 'Anguilla',
      by: '',
      pt: 'Anguila',
    },
    dial_code: '+1264',
    code: 'AI',
    flag: '🇦🇮',
  },
  {
    name: {
      en: 'Antarctica',
      ru: 'Антарктида',
      pl: 'Antarktyda',
      ua: 'Антарктида',
      cz: 'Antarktida',
      by: '',
      pt: 'Antarctica',
    },
    dial_code: '+672',
    code: 'AQ',
    flag: '🇦🇶',
  },
  {
    name: {
      en: 'Antigua and Barbuda',
      ru: 'Антигуа и Барбуда',
      pl: 'Antigua i Barbuda',
      ua: 'Антигуа та Барбуда',
      cz: 'Antigua a Barbuda',
      by: '',
      pt: 'Antiga e Barbuda',
    },
    dial_code: '+1268',
    code: 'AG',
    flag: '🇦🇬',
  },
  {
    name: {
      en: 'Argentina',
      ru: 'Аргентина',
      pl: 'Argentyna',
      ua: 'Аргентина',
      cz: 'Argentina',
      by: '',
      pt: 'Argentina',
    },
    dial_code: '+54',
    code: 'AR',
    flag: '🇦🇷',
  },
  {
    name: {
      en: 'Armenia',
      ru: 'Армения',
      pl: 'Armenia',
      ua: 'Вірменія',
      cz: 'Arménie',
      by: '',
      pt: 'Arménia',
    },
    dial_code: '+374',
    code: 'AM',
    flag: '🇦🇲',
  },
  {
    name: {
      en: 'Aruba',
      ru: 'Аруба',
      pl: 'Aruba',
      ua: 'Аруба',
      cz: 'Aruba',
      by: '',
      pt: 'Aruba',
    },
    dial_code: '+297',
    code: 'AW',
    flag: '🇦🇼',
  },
  {
    name: {
      en: 'Australia',
      ru: 'Австралия',
      pl: 'Australia',
      ua: 'Австралія',
      cz: 'Austrálie',
      by: '',
      pt: 'Austrália',
    },
    dial_code: '+61',
    code: 'AU',
    flag: '🇦🇺',
  },
  {
    name: {
      en: 'Austria',
      ru: 'Австрия',
      pl: 'Austria',
      ua: 'Австрія',
      cz: 'Rakousko',
      by: '',
      pt: 'Áustria',
    },
    dial_code: '+43',
    code: 'AT',
    flag: '🇦🇹',
  },
  {
    name: {
      en: 'Azerbaijan',
      ru: 'Азербайджан',
      pl: 'Azerbejdżan',
      ua: 'Азербайджан',
      cz: 'Ázerbajdžán',
      by: '',
      pt: 'Azerbaijão',
    },
    dial_code: '+994',
    code: 'AZ',
    flag: '🇦🇿',
  },
  {
    name: {
      en: 'Bahamas',
      ru: 'Багамские Острова',
      pl: 'Bahamy',
      ua: 'Багамські острови',
      cz: 'Bahamy',
      by: '',
      pt: 'Baamas',
    },
    dial_code: '+1242',
    code: 'BS',
    flag: '🇧🇸',
  },
  {
    name: {
      en: 'Bahrain',
      ru: 'Бахрейн',
      pl: 'Bahrajn',
      ua: 'Бахрейн',
      cz: 'Bahrajn',
      by: '',
      pt: 'Barém',
    },
    dial_code: '+973',
    code: 'BH',
    flag: '🇧🇭',
  },
  {
    name: {
      en: 'Bangladesh',
      ru: 'Бангладеш',
      pl: 'Bangladesz',
      ua: 'Бангладеш',
      cz: 'Bangladéš',
      by: '',
      pt: 'Bangladeche',
    },
    dial_code: '+880',
    code: 'BD',
    flag: '🇧🇩',
  },
  {
    name: {
      en: 'Barbados',
      ru: 'Барбадос',
      pl: 'Barbados',
      ua: 'Барбадос',
      cz: 'Barbados',
      by: '',
      pt: 'Barbados',
    },
    dial_code: '+1246',
    code: 'BB',
    flag: '🇧🇧',
  },
  {
    name: {
      en: 'Belarus',
      ru: 'Белоруссия',
      pl: 'Białoruś',
      ua: 'Білорусь',
      cz: 'Bělorusko',
      by: '',
      pt: 'Bielorrússia',
    },
    dial_code: '+375',
    code: 'BY',
    flag: '🇧🇾',
  },
  {
    name: {
      en: 'Belgium',
      ru: 'Бельгия',
      pl: 'Belgia',
      ua: 'Бельгія',
      cz: 'Belgie',
      by: '',
      pt: 'Bélgica',
    },
    dial_code: '+32',
    code: 'BE',
    flag: '🇧🇪',
  },
  {
    name: {
      en: 'Belize',
      ru: 'Белиз',
      pl: 'Belize',
      ua: 'Беліз',
      cz: 'Belize',
      by: '',
      pt: 'Belize',
    },
    dial_code: '+501',
    code: 'BZ',
    flag: '🇧🇿',
  },
  {
    name: {
      en: 'Benin',
      ru: 'Бенин',
      pl: 'Benin',
      ua: 'Бенін',
      cz: 'Benin',
      by: '',
      pt: 'Benim',
    },
    dial_code: '+229',
    code: 'BJ',
    flag: '🇧🇯',
  },
  {
    name: {
      en: 'Bermuda',
      ru: 'Бермуды',
      pl: 'Bermudy',
      ua: 'Бермуди',
      cz: 'Bermudy',
      by: '',
      pt: 'Bermudas',
    },
    dial_code: '+1441',
    code: 'BM',
    flag: '🇧🇲',
  },
  {
    name: {
      en: 'Bhutan',
      ru: 'Бутан',
      pl: 'Bhutan',
      ua: 'Бутан',
      cz: 'Bhútán',
      by: '',
      pt: 'Butão',
    },
    dial_code: '+975',
    code: 'BT',
    flag: '🇧🇹',
  },
  {
    name: {
      en: 'Bolivia',
      ru: 'Боливия',
      pl: 'Boliwia',
      ua: 'Болівія',
      cz: 'Bolívie',
      by: '',
      pt: 'Bolívia',
    },
    dial_code: '+591',
    code: 'BO',
    flag: '🇧🇴',
  },
  {
    name: {
      en: 'Bosnia and Herzegovina',
      ru: 'Босния и Герцеговина',
      pl: 'Bośnia i Hercegowina',
      ua: 'Боснія і Герцеговина',
      cz: 'Bosna a Hercegovina',
      by: '',
      pt: 'Bósnia e Herzegovina',
    },
    dial_code: '+387',
    code: 'BA',
    flag: '🇧🇦',
  },
  {
    name: {
      en: 'Botswana',
      ru: 'Ботсвана',
      pl: 'Botswana',
      ua: 'Ботсвана',
      cz: 'Botswana',
      by: '',
      pt: 'Botsuana',
    },
    dial_code: '+267',
    code: 'BW',
    flag: '🇧🇼',
  },
  {
    name: {
      en: 'Brazil',
      ru: 'Бразилия',
      pl: 'Brazylia',
      ua: 'Бразилія',
      cz: 'Brazílie',
      by: '',
      pt: 'Brasil',
    },
    dial_code: '+55',
    code: 'BR',
    flag: '🇧🇷',
  },
  {
    name: {
      en: 'British Indian Ocean Territory',
      ru: 'Британская территория Индийского океана',
      pl: 'Brytyjskie Terytorium Oceanu Indyjskiego',
      ua: 'Британська територія в Індійському океані',
      cz: 'Britské území v Indickém oceánu',
      by: '',
      pt: 'Território Britânico do Oceano Índico',
    },
    dial_code: '+246',
    code: 'IO',
    flag: '🇮🇴',
  },
  {
    name: {
      en: 'Brunei Darussalam',
      ru: 'Бруней-Даруссалам',
      pl: 'Brunei Darussalam',
      ua: 'Бруней-Даруссалам',
      cz: 'Brunej Darussalam',
      by: '',
      pt: 'Brunei',
    },
    dial_code: '+673',
    code: 'BN',
    flag: '🇧🇳',
  },
  {
    name: {
      en: 'Bulgaria',
      ru: 'Болгария',
      pl: 'Bułgaria',
      ua: 'Болгарія',
      cz: 'Bulharsko',
      by: '',
      pt: 'Bulgária',
    },
    dial_code: '+359',
    code: 'BG',
    flag: '🇧🇬',
  },
  {
    name: {
      en: 'Burkina Faso',
      ru: 'Буркина-Фасо',
      pl: 'Burkina Faso',
      ua: 'Буркіна-Фасо',
      cz: 'Burkina Faso',
      by: '',
      pt: 'Burquina Faso',
    },
    dial_code: '+226',
    code: 'BF',
    flag: '🇧🇫',
  },
  {
    name: {
      en: 'Burundi',
      ru: 'Бурунди',
      pl: 'Burundi',
      ua: 'Бурунді',
      cz: 'Burundi',
      by: '',
      pt: 'Burúndi',
    },
    dial_code: '+257',
    code: 'BI',
    flag: '🇧🇮',
  },
  {
    name: {
      en: 'Cambodia',
      ru: 'Камбоджа',
      pl: 'Kambodża',
      ua: 'Камбоджа',
      cz: 'Kambodža',
      by: '',
      pt: 'Camboja',
    },
    dial_code: '+855',
    code: 'KH',
    flag: '🇰🇭',
  },
  {
    name: {
      en: 'Cameroon',
      ru: 'Камерун',
      pl: 'Kamerun',
      ua: 'Камерун',
      cz: 'Kamerun',
      by: '',
      pt: 'Camarões',
    },
    dial_code: '+237',
    code: 'CM',
    flag: '🇨🇲',
  },
  {
    name: {
      en: 'Canada',
      ru: 'Канада',
      pl: 'Kanada',
      ua: 'Канада',
      cz: 'Kanada',
      by: '',
      pt: 'Canadá',
    },
    dial_code: '+1',
    code: 'CA',
    flag: '🇨🇦',
  },
  {
    name: {
      en: 'Cape Verde',
      ru: 'Кабо-Верде',
      pl: 'Wyspy Zielonego Przylądka',
      ua: 'Кабо-Верде',
      cz: 'Kapverdy',
      by: '',
      pt: 'Cabo Verde',
    },
    dial_code: '+238',
    code: 'CV',
    flag: '🇨🇻',
  },
  {
    name: {
      en: 'Cayman Islands',
      ru: 'Каймановы острова',
      pl: 'Kajmany',
      ua: 'Кайманові острови',
      cz: 'Kajmanské ostrovy',
      by: '',
      pt: 'Ilhas Caimão',
    },
    dial_code: '+345',
    code: 'KY',
    flag: '🇰🇾',
  },
  {
    name: {
      en: 'Central African Republic',
      ru: 'Центрально-Африканская Республика',
      pl: 'Republika Środkowoafrykańska',
      ua: 'Центральноафриканська Республіка',
      cz: 'Středoafrická republika',
      by: '',
      pt: 'República Centro-Africana',
    },
    dial_code: '+236',
    code: 'CF',
    flag: '🇨🇫',
  },
  {
    name: {
      en: 'Chad',
      ru: 'Чад',
      pl: 'Czad',
      ua: 'Чад',
      cz: 'Čad',
      by: '',
      pt: 'Chade',
    },
    dial_code: '+235',
    code: 'TD',
    flag: '🇹🇩',
  },
  {
    name: {
      en: 'Chile',
      ru: 'Чили',
      pl: 'Chile',
      ua: 'Чилі',
      cz: 'Chile',
      by: '',
      pt: 'Chile',
    },
    dial_code: '+56',
    code: 'CL',
    flag: '🇨🇱',
  },
  {
    name: {
      en: 'China',
      ru: 'Китай',
      pl: 'Chiny',
      ua: 'Китай',
      cz: 'Čína',
      by: '',
      pt: 'China',
    },
    dial_code: '+86',
    code: 'CN',
    flag: '🇨🇳',
  },
  {
    name: {
      en: 'Christmas Island',
      ru: 'Остров Рождества',
      pl: 'Wyspa Bożego Narodzenia',
      ua: 'Острів Різдва',
      cz: 'Vánoční ostrov',
      by: '',
      pt: 'Ilha do Natal',
    },
    dial_code: '+61',
    code: 'CX',
    flag: '🇨🇽',
  },
  {
    name: {
      en: 'Cocos (Keeling) Islands',
      ru: 'Кокосовые (Килинг) острова',
      pl: 'Wyspy Kokosowe (Keelinga)',
      ua: 'Кокосові (Кілінг) острови',
      cz: 'Kokosové (Keelingovy) ostrovy',
      by: '',
      pt: 'Ilhas dos Cocos',
    },
    dial_code: '+61',
    code: 'CC',
    flag: '🇨🇨',
  },
  {
    name: {
      en: 'Colombia',
      ru: 'Колумбия',
      pl: 'Kolumbia',
      ua: 'Колумбія',
      cz: 'Kolumbie',
      by: '',
      pt: 'Colômbia',
    },
    dial_code: '+57',
    code: 'CO',
    flag: '🇨🇴',
  },
  {
    name: {
      en: 'Comoros',
      ru: 'Коморские острова',
      pl: 'Komory',
      ua: 'Коморські острови',
      cz: 'Komory',
      by: '',
      pt: 'Comores',
    },
    dial_code: '+269',
    code: 'KM',
    flag: '🇰🇲',
  },
  {
    name: {
      en: 'Congo',
      ru: 'Конго',
      pl: 'Kongo',
      ua: 'Конго',
      cz: 'Kongo',
      by: '',
      pt: 'Congo-Brazzaville',
    },
    dial_code: '+242',
    code: 'CG',
    flag: '🇨🇬',
  },
  {
    name: {
      en: 'Congo, The Democratic Republic of the',
      ru: 'Конго, Демократическая Республика',
      pl: 'Kongo, Republika Demokratyczna',
      ua: 'Конго, Демократична Республіка',
      cz: 'Kongo, Demokratická Republika',
      by: '',
      pt: 'Congo-Kinshasa',
    },
    dial_code: '+243',
    code: 'CD',
    flag: '🇨🇩',
  },
  {
    name: {
      en: 'Cook Islands',
      ru: 'Острова Кука',
      pl: 'Wyspy Cooka',
      ua: 'Острови Кука',
      cz: 'Cookovy ostrovy',
      by: '',
      pt: 'Ilhas Cook',
    },
    dial_code: '+682',
    code: 'CK',
    flag: '🇨🇰',
  },
  {
    name: {
      en: 'Costa Rica',
      ru: 'Коста-Рика',
      pl: 'Kostaryka',
      ua: 'Коста-Ріка',
      cz: 'Kostarika',
      by: '',
      pt: 'Costa Rica',
    },
    dial_code: '+506',
    code: 'CR',
    flag: '🇨🇷',
  },
  {
    name: {
      en: "Cote d'Ivoire",
      ru: "Кот-д'Ивуар",
      pl: 'Wybrzeże Kości Słoniowej',
      ua: "Кот-д'Івуар",
      cz: 'Pobřeží slonoviny',
      by: '',
      pt: 'Costa do Marfim',
    },
    dial_code: '+225',
    code: 'CI',
    flag: '🇨🇮',
  },
  {
    name: {
      en: 'Croatia',
      ru: 'Хорватия',
      pl: 'Chorwacja',
      ua: 'Хорватія',
      cz: 'Chorvatsko',
      by: '',
      pt: 'Croácia',
    },
    dial_code: '+385',
    code: 'HR',
    flag: '🇭🇷',
  },
  {
    name: {
      en: 'Cuba',
      ru: 'Куба',
      pl: 'Kuba',
      ua: 'Куба',
      cz: 'Kuba',
      by: '',
      pt: 'Cuba',
    },
    dial_code: '+53',
    code: 'CU',
    flag: '🇨🇺',
  },
  {
    name: {
      en: 'Cyprus',
      ru: 'Кипр',
      pl: 'Cypr',
      ua: 'Кіпр',
      cz: 'Kypr',
      by: '',
      pt: 'Chipre',
    },
    dial_code: '+537',
    code: 'CY',
    flag: '🇨🇾',
  },
  {
    name: {
      en: 'Czech Republic',
      ru: 'Чехия',
      pl: 'Republika Czeska',
      ua: 'Чеська Республіка',
      cz: 'Česká republika',
      by: '',
      pt: 'República Checa',
    },
    dial_code: '+420',
    code: 'CZ',
    flag: '🇨🇿',
  },
  {
    name: {
      en: 'Denmark',
      ru: 'Дания',
      pl: 'Dania',
      ua: 'Данія',
      cz: 'Dánsko',
      by: '',
      pt: 'Dinamarca',
    },
    dial_code: '+45',
    code: 'DK',
    flag: '🇩🇰',
  },
  {
    name: {
      en: 'Djibouti',
      ru: 'Джибути',
      pl: 'Dżibuti',
      ua: 'Джибуті',
      cz: 'Džibuti',
      by: '',
      pt: 'Jibuti',
    },
    dial_code: '+253',
    code: 'DJ',
    flag: '🇩🇯',
  },
  {
    name: {
      en: 'Dominica',
      ru: 'Доминика',
      pl: 'Dominika',
      ua: 'Домініка',
      cz: 'Dominika',
      by: '',
      pt: 'Domínica',
    },
    dial_code: '+1767',
    code: 'DM',
    flag: '🇩🇲',
  },
  {
    name: {
      en: 'Dominican Republic',
      ru: 'Доминиканская Респблика',
      pl: 'Republika Dominikany',
      ua: 'Домініканська республіка',
      cz: 'Dominikánská republika',
      by: '',
      pt: 'República Dominicana',
    },
    dial_code: '+1849',
    code: 'DO',
    flag: '🇩🇴',
  },
  {
    name: {
      en: 'Ecuador',
      ru: 'Эквадор',
      pl: 'Ekwador',
      ua: 'Еквадор',
      cz: 'Ekvádor',
      by: '',
      pt: 'Equador',
    },
    dial_code: '+593',
    code: 'EC',
    flag: '🇪🇨',
  },
  {
    name: {
      en: 'Egypt',
      ru: 'Египет',
      pl: 'Egipt',
      ua: 'Єгипет',
      cz: 'Egypt',
      by: '',
      pt: 'Egipto',
    },
    dial_code: '+20',
    code: 'EG',
    flag: '🇪🇬',
  },
  {
    name: {
      en: 'El Salvador',
      ru: 'Сальвадор',
      pl: 'Salwador',
      ua: 'Сальвадор',
      cz: 'El Salvador',
      by: '',
      pt: 'Salvador',
    },
    dial_code: '+503',
    code: 'SV',
    flag: '🇸🇻',
  },
  {
    name: {
      en: 'Equatorial Guinea',
      ru: 'Экваториальная Гвинея',
      pl: 'Gwinea Równikowa',
      ua: 'Екваторіальна Гвінея',
      cz: 'Rovníková Guinea',
      by: '',
      pt: 'Guiné Equatorial',
    },
    dial_code: '+240',
    code: 'GQ',
    flag: '🇬🇶',
  },
  {
    name: {
      en: 'Eritrea',
      ru: 'Эритрея',
      pl: 'Erytrea',
      ua: 'Еритрея',
      cz: 'Eritrea',
      by: '',
      pt: 'Eritreia',
    },
    dial_code: '+291',
    code: 'ER',
    flag: '🇪🇷',
  },
  {
    name: {
      en: 'Estonia',
      ru: 'Эстония',
      pl: 'Estonia',
      ua: 'Естонія',
      cz: 'Estonsko',
      by: '',
      pt: 'Estónia',
    },
    dial_code: '+372',
    code: 'EE',
    flag: '🇪🇪',
  },
  {
    name: {
      en: 'Ethiopia',
      ru: 'Эфиопия',
      pl: 'Etiopia',
      ua: 'Ефіопія',
      cz: 'Etiopie',
      by: '',
      pt: 'Etiópia',
    },
    dial_code: '+251',
    code: 'ET',
    flag: '🇪🇹',
  },
  {
    name: {
      en: 'Falkland Islands (Malvinas)',
      ru: 'Фолклендские острова (Malvinas)',
      pl: 'Falklandy (Malwiny)',
      ua: 'Фолклендські острови (Мальвінські острови)',
      cz: 'Falklandské ostrovy (Malvíny)',
      by: '',
      pt: 'Ilhas Falkland',
    },
    dial_code: '+500',
    code: 'FK',
    flag: '🇫🇰',
  },
  {
    name: {
      en: 'Faroe Islands',
      ru: 'Фарерские острова',
      pl: 'Wyspy Owcze',
      ua: 'Фарерські острови',
      cz: 'Faerské ostrovy',
      by: '',
      pt: 'Faroé',
    },
    dial_code: '+298',
    code: 'FO',
    flag: '🇫🇴',
  },
  {
    name: {
      en: 'Fiji',
      ru: 'Фиджи',
      pl: 'Fidżi',
      ua: 'Фіджі',
      cz: 'Fidži',
      by: '',
      pt: 'Fiji',
    },
    dial_code: '+679',
    code: 'FJ',
    flag: '🇫🇯',
  },
  {
    name: {
      en: 'Finland',
      ru: 'Финляндия',
      pl: 'Finlandia',
      ua: 'Фінляндія',
      cz: 'Finsko',
      by: '',
      pt: 'Finlândia',
    },
    dial_code: '+358',
    code: 'FI',
    flag: '🇫🇮',
  },
  {
    name: {
      en: 'France',
      ru: 'Франция',
      pl: 'Francja',
      ua: 'Франція',
      cz: 'Francie',
      by: '',
      pt: 'França',
    },
    dial_code: '+33',
    code: 'FR',
    flag: '🇫🇷',
  },
  {
    name: {
      en: 'French Guiana',
      ru: 'Французская Гвиана',
      pl: 'Gujana Francuska',
      ua: 'Французька Гвіана',
      cz: 'Francouzská Guyana',
      by: '',
      pt: 'Guiana Francesa',
    },
    dial_code: '+594',
    code: 'GF',
    flag: '🇬🇫',
  },
  {
    name: {
      en: 'French Polynesia',
      ru: 'Французская Полинезия',
      pl: 'Polinezja Francuska',
      ua: 'Французька Полінезія',
      cz: 'Francouzská Polynésie',
      by: '',
      pt: 'Polinésia Francesa',
    },
    dial_code: '+689',
    code: 'PF',
    flag: '🇵🇫',
  },
  {
    name: {
      en: 'Gabon',
      ru: 'Габон',
      pl: 'Gabon',
      ua: 'Габон',
      cz: 'Gabon',
      by: '',
      pt: 'Gabão',
    },
    dial_code: '+241',
    code: 'GA',
    flag: '🇬🇦',
  },
  {
    name: {
      en: 'Gambia',
      ru: 'Гамбия',
      pl: 'Gambia',
      ua: 'Гамбія',
      cz: 'Gambie',
      by: '',
      pt: 'Gâmbia',
    },
    dial_code: '+220',
    code: 'GM',
    flag: '🇬🇲',
  },
  {
    name: {
      en: 'Georgia',
      ru: 'Грузия',
      pl: 'Gruzja',
      ua: 'Грузія',
      cz: 'Gruzie',
      by: '',
      pt: 'Geórgia',
    },
    dial_code: '+995',
    code: 'GE',
    flag: '🇬🇪',
  },
  {
    name: {
      en: 'Germany',
      ru: 'Германия',
      pl: 'Niemcy',
      ua: 'Німеччина',
      cz: 'Německo',
      by: '',
      pt: 'Alemanha',
    },
    dial_code: '+49',
    code: 'DE',
    flag: '🇩🇪',
  },
  {
    name: {
      en: 'Ghana',
      ru: 'Гана',
      pl: 'Ghana',
      ua: 'Гана',
      cz: 'Ghana',
      by: '',
      pt: 'Gana',
    },
    dial_code: '+233',
    code: 'GH',
    flag: '🇬🇭',
  },
  {
    name: {
      en: 'Gibraltar',
      ru: 'Гибралтар',
      pl: 'Gibraltar',
      ua: 'Гібралтар',
      cz: 'Gibraltar',
      by: '',
      pt: 'Gibraltar',
    },
    dial_code: '+350',
    code: 'GI',
    flag: '🇬🇮',
  },
  {
    name: {
      en: 'Greece',
      ru: 'Греция',
      pl: 'Grecja',
      ua: 'Греція',
      cz: 'Řecko',
      by: '',
      pt: 'Grécia',
    },
    dial_code: '+30',
    code: 'GR',
    flag: '🇬🇷',
  },
  {
    name: {
      en: 'Greenland',
      ru: 'Гренландия',
      pl: 'Grenlandia',
      ua: 'Гренландія',
      cz: 'Grenlandia',
      by: '',
      pt: 'Gronelândia',
    },
    dial_code: '+299',
    code: 'GL',
    flag: '🇬🇱',
  },
  {
    name: {
      en: 'Grenada',
      ru: 'Гренада',
      pl: 'Grenada',
      ua: 'Гренада',
      cz: 'Grenada',
      by: '',
      pt: 'Granada',
    },
    dial_code: '+1473',
    code: 'GD',
    flag: '🇬🇩',
  },
  {
    name: {
      en: 'Guadeloupe',
      ru: 'Гваделупа',
      pl: 'Gwadelupa',
      ua: 'Гваделупа',
      cz: 'Guadeloupe',
      by: '',
      pt: 'Guadalupe',
    },
    dial_code: '+590',
    code: 'GP',
    flag: '🇬🇵',
  },
  {
    name: {
      en: 'Guam',
      ru: 'Гуам',
      pl: 'Guam',
      ua: 'Гуам',
      cz: 'Guam',
      by: '',
      pt: 'Guame',
    },
    dial_code: '+1671',
    code: 'GU',
    flag: '🇬🇺',
  },
  {
    name: {
      en: 'Guatemala',
      ru: 'Гватемала',
      pl: 'Gwatemala',
      ua: 'Гватемала',
      cz: 'Guatemala',
      by: '',
      pt: 'Guatemala',
    },
    dial_code: '+502',
    code: 'GT',
    flag: '🇬🇹',
  },
  {
    name: {
      en: 'Guernsey',
      ru: 'Гернси',
      pl: 'Guernsey',
      ua: 'Гернсі',
      cz: 'Guernsey',
      by: '',
      pt: 'Guernsey',
    },
    dial_code: '+44',
    code: 'GG',
    flag: '🇬🇬',
  },
  {
    name: {
      en: 'Guinea',
      ru: 'Гвинея',
      pl: 'Gwinea',
      ua: 'Гвінея',
      cz: 'Guinea',
      by: '',
      pt: 'Guiné',
    },
    dial_code: '+224',
    code: 'GN',
    flag: '🇬🇳',
  },
  {
    name: {
      en: 'Guinea-Bissau',
      ru: 'Гвинея-Бисау',
      pl: 'Gwinea Bissau',
      ua: 'Гвінея-Бісау',
      cz: 'Guinea-Bissau',
      by: '',
      pt: 'Guiné-Bissau',
    },
    dial_code: '+245',
    code: 'GW',
    flag: '🇬🇼',
  },
  {
    name: {
      en: 'Guyana',
      ru: 'Гайана',
      pl: 'Gujana',
      ua: 'Гайана',
      cz: 'Guyana',
      by: '',
      pt: 'Guiana',
    },
    dial_code: '+595',
    code: 'GY',
    flag: '🇬🇾',
  },
  {
    name: {
      en: 'Haiti',
      ru: 'Гаити',
      pl: 'Haiti',
      ua: 'Гаїті',
      cz: 'Haiti',
      by: '',
      pt: 'Haiti',
    },
    dial_code: '+509',
    code: 'HT',
    flag: '🇭🇹',
  },
  {
    name: {
      en: 'Holy See (Vatican City State)',
      ru: 'Святой Престол (Vatican City State)',
      pl: 'Stolica Apostolska (Państwo Watykańskie)',
      ua: 'Святий Престол (Ватикан)',
      cz: 'Svatý stolec (Vatikánský městský stát)',
      by: '',
      pt: 'Vaticano',
    },
    dial_code: '+379',
    code: 'VA',
    flag: '🇻🇦',
  },
  {
    name: {
      en: 'Honduras',
      ru: 'Гондурас',
      pl: 'Honduras',
      ua: 'Гондурас',
      cz: 'Honduras',
      by: '',
      pt: 'Honduras',
    },
    dial_code: '+504',
    code: 'HN',
    flag: '🇭🇳',
  },
  {
    name: {
      en: 'Hong Kong',
      ru: 'Гонконг',
      pl: 'Hongkong',
      ua: 'Гонконг',
      cz: 'Hongkong',
      by: '',
      pt: 'Hong Kong',
    },
    dial_code: '+852',
    code: 'HK',
    flag: '🇭🇰',
  },
  {
    name: {
      en: 'Hungary',
      ru: 'Венгрия',
      pl: 'Węgry',
      ua: 'Угорщина',
      cz: 'Maďarsko',
      by: '',
      pt: 'Hungria',
    },
    dial_code: '+36',
    code: 'HU',
    flag: '🇭🇺',
  },
  {
    name: {
      en: 'Iceland',
      ru: 'Исландия',
      pl: 'Islandia',
      ua: 'Ісландія',
      cz: 'Island',
      by: '',
      pt: 'Islândia',
    },
    dial_code: '+354',
    code: 'IS',
    flag: '🇮🇸',
  },
  {
    name: {
      en: 'India',
      ru: 'Индия',
      pl: 'Indie',
      ua: 'Індія',
      cz: 'Indie',
      by: '',
      pt: 'Índia',
    },
    dial_code: '+91',
    code: 'IN',
    flag: '🇮🇳',
  },
  {
    name: {
      en: 'Indonesia',
      ru: 'Индонезия',
      pl: 'Indonezja',
      ua: 'Індонезія',
      cz: 'Indonésie',
      by: '',
      pt: 'Indonésia',
    },
    dial_code: '+62',
    code: 'ID',
    flag: '🇮🇩',
  },
  {
    name: {
      en: 'Iran, Islamic Republic of',
      ru: 'Иран, Исламская Республика',
      pl: 'Iran, Republika Islamska',
      ua: 'Іран, Ісламська Республіка',
      cz: 'Írán, Islámská Republika',
      by: '',
      pt: 'Irão',
    },
    dial_code: '+98',
    code: 'IR',
    flag: '🇮🇷',
  },
  {
    name: {
      en: 'Iraq',
      ru: 'Ирак',
      pl: 'Irak',
      ua: 'Ірак',
      cz: 'Irák',
      by: '',
      pt: 'Iraque',
    },
    dial_code: '+964',
    code: 'IQ',
    flag: '🇮🇶',
  },
  {
    name: {
      en: 'Ireland',
      ru: 'Ирландия',
      pl: 'Irlandia',
      ua: 'Ірландія',
      cz: 'Irsko',
      by: '',
      pt: 'Irlanda',
    },
    dial_code: '+353',
    code: 'IE',
    flag: '🇮🇪',
  },
  {
    name: {
      en: 'Isle of Man',
      ru: 'Остров Мэн',
      pl: 'Wyspa Man',
      ua: 'Острів Мен',
      cz: 'Isle of Man',
      by: '',
      pt: 'Ilha de Man',
    },
    dial_code: '+44',
    code: 'IM',
    flag: '🇮🇲',
  },
  {
    name: {
      en: 'Israel',
      ru: 'Израиль',
      pl: 'Izrael',
      ua: 'Ізраїль',
      cz: 'Izrael',
      by: '',
      pt: 'Israel',
    },
    dial_code: '+972',
    code: 'IL',
    flag: '🇮🇱',
  },
  {
    name: {
      en: 'Italy',
      ru: 'Италия',
      pl: 'Włochy',
      ua: 'Італія',
      cz: 'Itálie',
      by: '',
      pt: 'Itália',
    },
    dial_code: '+39',
    code: 'IT',
    flag: '🇮🇹',
  },
  {
    name: {
      en: 'Jamaica',
      ru: 'Ямайка',
      pl: 'Jamajka',
      ua: 'Ямайка',
      cz: 'Jamaica',
      by: '',
      pt: 'Jamaica',
    },
    dial_code: '+1876',
    code: 'JM',
    flag: '🇯🇲',
  },
  {
    name: {
      en: 'Japan',
      ru: 'Япония',
      pl: 'Japonia',
      ua: 'Японія',
      cz: 'Japonsko',
      by: '',
      pt: 'Japão',
    },
    dial_code: '+81',
    code: 'JP',
    flag: '🇯🇵',
  },
  {
    name: {
      en: 'Jersey',
      ru: 'Джерси',
      pl: 'Jersey',
      ua: 'Джерсі',
      cz: 'Trikot',
      by: '',
      pt: 'Jersey',
    },
    dial_code: '+44',
    code: 'JE',
    flag: '🇯🇪',
  },
  {
    name: {
      en: 'Jordan',
      ru: 'Иордания',
      pl: 'Jordania',
      ua: 'Йорданія',
      cz: 'Jordán',
      by: '',
      pt: 'Jordânia',
    },
    dial_code: '+962',
    code: 'JO',
    flag: '🇯🇴',
  },
  {
    name: {
      en: 'Kazakhstan',
      ru: 'Казахстан',
      pl: 'Kazachstan',
      ua: 'Казахстан',
      cz: 'Kazachstán',
      by: '',
      pt: 'Cazaquistão',
    },
    dial_code: '+77',
    code: 'KZ',
    flag: '🇰🇿',
  },
  {
    name: {
      en: 'Kenya',
      ru: 'Кения',
      pl: 'Kenia',
      ua: 'Кенія',
      cz: 'Keňa',
      by: '',
      pt: 'Quénia',
    },
    dial_code: '+254',
    code: 'KE',
    flag: '🇰🇪',
  },
  {
    name: {
      en: 'Kiribati',
      ru: 'Кирибати',
      pl: 'Kiribati',
      ua: 'Kiribati',
      cz: 'Kiribati',
      by: '',
      pt: 'Quiribáti',
    },
    dial_code: '+686',
    code: 'KI',
    flag: '🇰🇮',
  },
  {
    name: {
      en: "Korea, Democratic People's Republic of",
      ru: 'Корея, Народно-Демократическая Республика',
      pl: 'Korea, Republika Ludowo-Demokratyczna',
      ua: 'Корея, Народно-Демократична Республіка',
      cz: 'Korea, Demokratická lidová republika',
      by: '',
      pt: 'Coreia do Norte',
    },
    dial_code: '+850',
    code: 'KP',
    flag: '🇰🇵',
  },
  {
    name: {
      en: 'Korea, Republic of',
      ru: 'Республика Корея',
      pl: 'Republika Korei',
      ua: 'Корея, Республіка',
      cz: 'Korea, republika',
      by: '',
      pt: 'Coreia do Sul',
    },
    dial_code: '+82',
    code: 'KR',
    flag: '🇰🇷',
  },
  {
    name: {
      en: 'Kuwait',
      ru: 'Кувейт',
      pl: 'Kuwejt',
      ua: 'Кувейт',
      cz: 'Kuvajt',
      by: '',
      pt: 'Kuwait',
    },
    dial_code: '+965',
    code: 'KW',
    flag: '🇰🇼',
  },
  {
    name: {
      en: 'Kyrgyzstan',
      ru: 'Kyrgyzstan',
      pl: 'Kirgistan',
      ua: 'Киргизстан',
      cz: 'Kyrgyzstán',
      by: '',
      pt: 'Quirguizistão',
    },
    dial_code: '+996',
    code: 'KG',
    flag: '🇰🇬',
  },
  {
    name: {
      en: "Lao People's Democratic Republic",
      ru: 'Лаосская Народно-Демократическая Республика',
      pl: 'Laotańska Republika Ludowo-Demokratyczna',
      ua: 'Лаоська Народно-Демократична Республіка',
      cz: 'Laoská lidově demokratická republika',
      by: '',
      pt: 'Laos',
    },
    dial_code: '+856',
    code: 'LA',
    flag: '🇱🇦',
  },
  {
    name: {
      en: 'Latvia',
      ru: 'Латвия',
      pl: 'Łotwa',
      ua: 'Латвія',
      cz: 'Lotyšsko',
      by: '',
      pt: 'Letónia',
    },
    dial_code: '+371',
    code: 'LV',
    flag: '🇱🇻',
  },
  {
    name: {
      en: 'Lebanon',
      ru: 'Ливан',
      pl: 'Liban',
      ua: 'Ліван',
      cz: 'Libanon',
      by: '',
      pt: 'Líbano',
    },
    dial_code: '+961',
    code: 'LB',
    flag: '🇱🇧',
  },
  {
    name: {
      en: 'Lesotho',
      ru: 'Лесото',
      pl: 'Lesoto',
      ua: 'Лесото',
      cz: 'Lesotho',
      by: '',
      pt: 'Lesoto',
    },
    dial_code: '+266',
    code: 'LS',
    flag: '🇱🇸',
  },
  {
    name: {
      en: 'Liberia',
      ru: 'Либерия',
      pl: 'Liberia',
      ua: 'Ліберія',
      cz: 'Libérie',
      by: '',
      pt: 'Libéria',
    },
    dial_code: '+231',
    code: 'LR',
    flag: '🇱🇷',
  },
  {
    name: {
      en: 'Libyan Arab Jamahiriya',
      ru: 'Ливийская Арабская Джамахирия',
      pl: 'Libijska Arabska Dżamahirija',
      ua: 'Лівійська Арабська Джамахірія',
      cz: 'Libyjský Arab Jamahiriya',
      by: '',
      pt: 'Líbia',
    },
    dial_code: '+218',
    code: 'LY',
    flag: '🇱🇾',
  },
  {
    name: {
      en: 'Liechtenstein',
      ru: 'Лихтенштейн',
      pl: 'Liechtenstein',
      ua: 'Ліхтенштейн',
      cz: 'Lichtenštejnsko',
      by: '',
      pt: 'Listenstaine',
    },
    dial_code: '+423',
    code: 'LI',
    flag: '🇱🇮',
  },
  {
    name: {
      en: 'Lithuania',
      ru: 'Литва',
      pl: 'Litwa',
      ua: 'Литва',
      cz: 'Litva',
      by: '',
      pt: 'Lituânia',
    },
    dial_code: '+370',
    code: 'LT',
    flag: '🇱🇹',
  },
  {
    name: {
      en: 'Luxembourg',
      ru: 'Люксембург',
      pl: 'Luksemburg',
      ua: 'Люксембург',
      cz: 'Lucembursko',
      by: '',
      pt: 'Luxemburgo',
    },
    dial_code: '+352',
    code: 'LU',
    flag: '🇱🇺',
  },
  {
    name: {
      en: 'Macao',
      ru: 'Макао',
      pl: 'Makao',
      ua: 'Макао',
      cz: 'Macao',
      by: '',
      pt: 'Macau',
    },
    dial_code: '+853',
    code: 'MO',
    flag: '🇲🇴',
  },
  {
    name: {
      en: 'Macedonia, The Former Yugoslav Republic of',
      ru: 'Македония, Бывшая Югославская Республика',
      pl: 'Macedonia, Była Jugosłowiańska Republika',
      ua: 'Македонія, колишня югославська республіка',
      cz: 'Makedonie, Bývalá jugoslávská republika',
      by: '',
      pt: 'Macedónia',
    },
    dial_code: '+389',
    code: 'MK',
    flag: '🇲🇰',
  },
  {
    name: {
      en: 'Madagascar',
      ru: 'Мадагаскар',
      pl: 'Madagaskar',
      ua: 'Мадагаскар',
      cz: 'Madagaskar',
      by: '',
      pt: 'Madagáscar',
    },
    dial_code: '+261',
    code: 'MG',
    flag: '🇲🇬',
  },
  {
    name: {
      en: 'Malawi',
      ru: 'Малави',
      pl: 'Malawi',
      ua: 'Малаві',
      cz: 'Malawi',
      by: '',
      pt: 'Malávi',
    },
    dial_code: '+265',
    code: 'MW',
    flag: '🇲🇼',
  },
  {
    name: {
      en: 'Malaysia',
      ru: 'Малайзия',
      pl: 'Malezja',
      ua: 'Малайзія',
      cz: 'Malajsie',
      by: '',
      pt: 'Malásia',
    },
    dial_code: '+60',
    code: 'MY',
    flag: '🇲🇾',
  },
  {
    name: {
      en: 'Maldives',
      ru: 'Мальдивы',
      pl: 'Malediwy',
      ua: 'Мальдіви',
      cz: 'Maledivy',
      by: '',
      pt: 'Maldivas',
    },
    dial_code: '+960',
    code: 'MV',
    flag: '🇲🇻',
  },
  {
    name: {
      en: 'Mali',
      ru: 'Мали',
      pl: 'Mali',
      ua: 'Малі',
      cz: 'Mali',
      by: '',
      pt: 'Mali',
    },
    dial_code: '+223',
    code: 'ML',
    flag: '🇲🇱',
  },
  {
    name: {
      en: 'Malta',
      ru: 'Мальта',
      pl: 'Malta',
      ua: 'Мальта',
      cz: 'Malta',
      by: '',
      pt: 'Malta',
    },
    dial_code: '+356',
    code: 'MT',
    flag: '🇲🇹',
  },
  {
    name: {
      en: 'Marshall Islands',
      ru: 'Маршалловы острова',
      pl: 'Wyspy Marshalla',
      ua: 'Маршаллові острови',
      cz: 'Marshallovy ostrovy',
      by: '',
      pt: 'Ilhas Marshall',
    },
    dial_code: '+692',
    code: 'MH',
    flag: '🇲🇭',
  },
  {
    name: {
      en: 'Martinique',
      ru: 'Мартиника',
      pl: 'Martynika',
      ua: 'Мартініка',
      cz: 'Martinik',
      by: '',
      pt: 'Martinica',
    },
    dial_code: '+596',
    code: 'MQ',
    flag: '🇲🇶',
  },
  {
    name: {
      en: 'Mauritania',
      ru: 'Мавритания',
      pl: 'Mauretania',
      ua: 'Мавританія',
      cz: 'Mauretánie',
      by: '',
      pt: 'Mauritânia',
    },
    dial_code: '+222',
    code: 'MR',
    flag: '🇲🇷',
  },
  {
    name: {
      en: 'Mauritius',
      ru: 'Маврикий',
      pl: 'Mauritius',
      ua: 'Маврикій',
      cz: 'Mauricius',
      by: '',
      pt: 'Maurícia',
    },
    dial_code: '+230',
    code: 'MU',
    flag: '🇲🇺',
  },
  {
    name: {
      en: 'Mayotte',
      ru: 'Майотта',
      pl: 'Majotta',
      ua: 'Майотта',
      cz: 'Mayotte',
      by: '',
      pt: 'Mayotte',
    },
    dial_code: '+262',
    code: 'YT',
    flag: '🇾🇹',
  },
  {
    name: {
      en: 'Mexico',
      ru: 'Мексика',
      pl: 'Meksyk',
      ua: 'Мексика',
      cz: 'Mexiko',
      by: '',
      pt: 'México',
    },
    dial_code: '+52',
    code: 'MX',
    flag: '🇲🇽',
  },
  {
    name: {
      en: 'Micronesia, Federated States of',
      ru: 'Микронезия, Федеративные Штаты',
      pl: 'Mikronezja, Sfederowane Stany',
      ua: 'Мікронезія, Федеративні Штати',
      cz: 'Mikronésie, federativní státy',
      by: '',
      pt: 'Micronésia',
    },
    dial_code: '+691',
    code: 'FM',
    flag: '🇫🇲',
  },
  {
    name: {
      en: 'Moldova, Republic of',
      ru: 'Молдова, Республика',
      pl: 'Mołdawia, Republika',
      ua: 'Молдова, республіка',
      cz: 'Moldavsko, republika',
      by: '',
      pt: 'Moldávia',
    },
    dial_code: '+373',
    code: 'MD',
    flag: '🇲🇩',
  },
  {
    name: {
      en: 'Monaco',
      ru: 'Монако',
      pl: 'Monako',
      ua: 'Монако',
      cz: 'Monako',
      by: '',
      pt: 'Mónaco',
    },
    dial_code: '+377',
    code: 'MC',
    flag: '🇲🇨',
  },
  {
    name: {
      en: 'Mongolia',
      ru: 'Монголия',
      pl: 'Mongolia',
      ua: 'Монголія',
      cz: 'Mongolsko',
      by: '',
      pt: 'Mongólia',
    },
    dial_code: '+976',
    code: 'MN',
    flag: '🇲🇳',
  },
  {
    name: {
      en: 'Montenegro',
      ru: 'Черногория',
      pl: 'Czarnogóra',
      ua: 'Чорногорія',
      cz: 'Černá Hora',
      by: '',
      pt: 'Montenegro',
    },
    dial_code: '+382',
    code: 'ME',
    flag: '🇲🇪',
  },
  {
    name: {
      en: 'Montserrat',
      ru: 'Монтсеррат',
      pl: 'Montserrat',
      ua: 'Монтсеррат',
      cz: 'Montserrat',
      by: '',
      pt: 'Monserrate',
    },
    dial_code: '+1664',
    code: 'MS',
    flag: '🇲🇸',
  },
  {
    name: {
      en: 'Morocco',
      ru: 'Марокко',
      pl: 'Maroko',
      ua: 'Марокко',
      cz: 'Maroko',
      by: '',
      pt: 'Marrocos',
    },
    dial_code: '+212',
    code: 'MA',
    flag: '🇲🇦',
  },
  {
    name: {
      en: 'Mozambique',
      ru: 'Мозамбик',
      pl: 'Mozambik',
      ua: 'Мозамбік',
      cz: 'Mosambik',
      by: '',
      pt: 'Moçambique',
    },
    dial_code: '+258',
    code: 'MZ',
    flag: '🇲🇿',
  },
  {
    name: {
      en: 'Myanmar',
      ru: 'Мьянма',
      pl: 'Myanmar',
      ua: "М'янма",
      cz: 'Myanmar',
      by: '',
      pt: 'Birmânia',
    },
    dial_code: '+95',
    code: 'MM',
    flag: '🇲🇲',
  },
  {
    name: {
      en: 'Namibia',
      ru: 'Намибия',
      pl: 'Namibia',
      ua: 'Намібія',
      cz: 'Namibie',
      by: '',
      pt: 'Namíbia',
    },
    dial_code: '+264',
    code: 'NA',
    flag: '🇳🇦',
  },
  {
    name: {
      en: 'Nauru',
      ru: 'Науру',
      pl: 'Nauru',
      ua: 'Науру',
      cz: 'Nauru',
      by: '',
      pt: 'Nauru',
    },
    dial_code: '+674',
    code: 'NR',
    flag: '🇳🇷',
  },
  {
    name: {
      en: 'Nepal',
      ru: 'Непал',
      pl: 'Nepal',
      ua: 'Непал',
      cz: 'Nepál',
      by: '',
      pt: 'Nepal',
    },
    dial_code: '+977',
    code: 'NP',
    flag: '🇳🇵',
  },
  {
    name: {
      en: 'Netherlands',
      ru: 'Нидерланды',
      pl: 'Holandia',
      ua: 'Нідерланди',
      cz: 'Holandsko',
      by: '',
      pt: 'Países Baixos',
    },
    dial_code: '+31',
    code: 'NL',
    flag: '🇳🇱',
  },
  {
    name: {
      en: 'Netherlands Antilles',
      ru: 'Нидерландские Антильские острова',
      pl: 'Antyle Holenderskie',
      ua: 'Нідерландські Антильські острови',
      cz: 'Nizozemské Antily',
      by: '',
      pt: 'Antilhas Neerlandesas',
    },
    dial_code: '+599',
    code: 'AN',
    flag: '🇦🇳',
  },
  {
    name: {
      en: 'New Caledonia',
      ru: 'Новая Каледония',
      pl: 'Nowa Kaledonia',
      ua: 'Нова Каледонія',
      cz: 'Nová Kaledonie',
      by: '',
      pt: 'Nova Caledónia',
    },
    dial_code: '+687',
    code: 'NC',
    flag: '🇳🇨',
  },
  {
    name: {
      en: 'New Zealand',
      ru: 'Новая Зеландия',
      pl: 'Nowa Zelandia',
      ua: 'Нова Зеландія',
      cz: 'Nový Zéland',
      by: '',
      pt: 'Nova Zelândia',
    },
    dial_code: '+64',
    code: 'NZ',
    flag: '🇳🇿',
  },
  {
    name: {
      en: 'Nicaragua',
      ru: 'Никарагуа',
      pl: 'Nikaragua',
      ua: 'Нікарагуа',
      cz: 'Nikaragua',
      by: '',
      pt: 'Nicarágua',
    },
    dial_code: '+505',
    code: 'NI',
    flag: '🇳🇮',
  },
  {
    name: {
      en: 'Niger',
      ru: 'Нигер',
      pl: 'Niger',
      ua: 'Нігер',
      cz: 'Niger',
      by: '',
      pt: 'Níger',
    },
    dial_code: '+227',
    code: 'NE',
    flag: '🇳🇪',
  },
  {
    name: {
      en: 'Nigeria',
      ru: 'Нигерия',
      pl: 'Nigeria',
      ua: 'Нігерія',
      cz: 'Nigérie',
      by: '',
      pt: 'Nigéria',
    },
    dial_code: '+234',
    code: 'NG',
    flag: '🇳🇬',
  },
  {
    name: {
      en: 'Niue',
      ru: 'Ниуэ',
      pl: 'Niue',
      ua: 'Ніуе',
      cz: 'Niue',
      by: '',
      pt: 'Niue',
    },
    dial_code: '+683',
    code: 'NU',
    flag: '🇳🇺',
  },
  {
    name: {
      en: 'Norfolk Island',
      ru: 'Остров Норфолк',
      pl: 'Wyspa Norfolk',
      ua: 'Острів Норфолк',
      cz: 'Ostrov Norfolk',
      by: '',
      pt: 'Ilha Norfolk',
    },
    dial_code: '+672',
    code: 'NF',
    flag: '🇳🇫',
  },
  {
    name: {
      en: 'Northern Mariana Islands',
      ru: 'Северные Марианские острова',
      pl: 'Mariany Północne',
      ua: 'Північні Маріанські острови',
      cz: 'Severní Mariany',
      by: '',
      pt: 'Marianas do Norte',
    },
    dial_code: '+1670',
    code: 'MP',
    flag: '🇲🇵',
  },
  {
    name: {
      en: 'Norway',
      ru: 'Норвегия',
      pl: 'Norwegia',
      ua: 'Норвегія',
      cz: 'Norsko',
      by: '',
      pt: 'Noruega',
    },
    dial_code: '+47',
    code: 'NO',
    flag: '🇳🇴',
  },
  {
    name: {
      en: 'Oman',
      ru: 'Оман',
      pl: 'Oman',
      ua: 'Оман',
      cz: 'Omán',
      by: '',
      pt: 'Omã',
    },
    dial_code: '+968',
    code: 'OM',
    flag: '🇴🇲',
  },
  {
    name: {
      en: 'Pakistan',
      ru: 'Пакистан',
      pl: 'Pakistan',
      ua: 'Пакистан',
      cz: 'Pákistán',
      by: '',
      pt: 'Paquistão',
    },
    dial_code: '+92',
    code: 'PK',
    flag: '🇵🇰',
  },
  {
    name: {
      en: 'Palau',
      ru: 'Палау',
      pl: 'Palau',
      ua: 'Палау',
      cz: 'Palau',
      by: '',
      pt: 'Palau',
    },
    dial_code: '+680',
    code: 'PW',
    flag: '🇵🇼',
  },
  {
    name: {
      en: 'Palestinian Territory, Occupied',
      ru: 'Палестинская Территория, Оккупированная',
      pl: 'Teretorium Paleństynskie, Okupowane',
      ua: 'Палестинська територія, окупована',
      cz: 'Palestinské území, obsazené',
      by: '',
      pt: 'Território Palestino, Ocupado',
    },
    dial_code: '+970',
    code: 'PS',
    flag: '🇵🇸',
  },
  {
    name: {
      en: 'Panama',
      ru: 'Панама',
      pl: 'Panama',
      ua: 'Панама',
      cz: 'Panama',
      by: '',
      pt: 'Panamá',
    },
    dial_code: '+507',
    code: 'PA',
    flag: '🇵🇦',
  },
  {
    name: {
      en: 'Papua New Guinea',
      ru: 'Папуа - Новая Гвинея',
      pl: 'Papua Nowa Gwinea',
      ua: 'Папуа-Нова Гвінея',
      cz: 'Papua-Nová Guinea',
      by: '',
      pt: 'Papua-Nova Guiné',
    },
    dial_code: '+675',
    code: 'PG',
    flag: '🇵🇬',
  },
  {
    name: {
      en: 'Paraguay',
      ru: 'Парагвай',
      pl: 'Paragwaj',
      ua: 'Парагвай',
      cz: 'Paraguay',
      by: '',
      pt: 'Paraguai',
    },
    dial_code: '+595',
    code: 'PY',
    flag: '🇵🇾',
  },
  {
    name: {
      en: 'Peru',
      ru: 'Перу',
      pl: 'Peru',
      ua: 'Перу',
      cz: 'Peru',
      by: '',
      pt: 'Peru',
    },
    dial_code: '+51',
    code: 'PE',
    flag: '🇵🇪',
  },
  {
    name: {
      en: 'Philippines',
      ru: 'Филиппины',
      pl: 'Filipiny',
      ua: 'Філіппіни',
      cz: 'Filipíny',
      by: '',
      pt: 'Filipinas',
    },
    dial_code: '+63',
    code: 'PH',
    flag: '🇵🇭',
  },
  {
    name: {
      en: 'Pitcairn',
      ru: 'Питкэрн',
      pl: 'Pitcairn',
      ua: 'Піткерн',
      cz: 'Pitcairn',
      by: '',
      pt: 'Pitcairn',
    },
    dial_code: '+872',
    code: 'PN',
    flag: '🇵🇳',
  },
  {
    name: {
      en: 'Poland',
      ru: 'Польша',
      pl: 'Polska',
      ua: 'Польща',
      cz: 'Polsko',
      by: '',
      pt: 'Polónia',
    },
    dial_code: '+48',
    code: 'PL',
    flag: '🇵🇱',
  },
  {
    name: {
      en: 'Portugal',
      ru: 'Португалия',
      pl: 'Portugalia',
      ua: 'Португалія',
      cz: 'Portugalsko',
      by: '',
      pt: 'Portugal',
    },
    dial_code: '+351',
    code: 'PT',
    flag: '🇵🇹',
  },
  {
    name: {
      en: 'Puerto Rico',
      ru: 'Пуэрто-Рико',
      pl: 'Portoryko',
      ua: 'Пуерто Ріко',
      cz: 'Portoriko',
      by: '',
      pt: 'Porto Rico',
    },
    dial_code: '+1939',
    code: 'PR',
    flag: '🇵🇷',
  },
  {
    name: {
      en: 'Qatar',
      ru: 'Катар',
      pl: 'Katar',
      ua: 'Катар',
      cz: 'Katar',
      by: '',
      pt: 'Catar',
    },
    dial_code: '+974',
    code: 'QA',
    flag: '🇶🇦',
  },
  {
    name: {
      en: 'Romania',
      ru: 'Румыния',
      pl: 'Rumunia',
      ua: 'Румунія',
      cz: 'Rumunsko',
      by: '',
      pt: 'Roménia',
    },
    dial_code: '+40',
    code: 'RO',
    flag: '🇷🇴',
  },
  {
    name: {
      en: 'Russia',
      ru: 'Россия',
      pl: 'Rosja',
      ua: 'Росія',
      cz: 'Rusko',
      by: '',
      pt: 'Rússia',
    },
    dial_code: '+7',
    code: 'RU',
    flag: '🇷🇺',
  },
  {
    name: {
      en: 'Rwanda',
      ru: 'Руанда',
      pl: 'Rwanda',
      ua: 'Руанда',
      cz: 'Rwanda',
      by: '',
      pt: 'Ruanda',
    },
    dial_code: '+250',
    code: 'RW',
    flag: '🇷🇼',
  },
  {
    name: {
      en: 'Réunion',
      ru: 'Реюньон',
      pl: 'Réunion',
      ua: 'Реюньйон',
      cz: 'Réunion',
      by: '',
      pt: 'Reunião',
    },
    dial_code: '+262',
    code: 'RE',
    flag: '🇷🇪',
  },
  {
    name: {
      en: 'Saint Barthélemy',
      ru: 'Святой Варфоломей',
      pl: 'Saint Barthelemy',
      ua: 'Сен-Бартелемі',
      cz: 'Svatý Bartoloměj',
      by: '',
      pt: 'São Bartolomeu',
    },
    dial_code: '+590',
    code: 'BL',
    flag: '🇧🇱',
  },
  {
    name: {
      en: 'Saint Helena, Ascension and Tristan Da Cunha',
      ru: 'Святой Елены, Вознесения и Тристан-да-Кунья',
      pl: 'Święta Helena, Wniebowstąpienie i Tristan Da Cunha',
      ua: 'Свята Олена, Вознесіння і Трістан Да Кунья',
      cz: 'Svatá Helena, Nanebevstoupení a Tristan Da Cunha',
      by: '',
      pt: 'Santa Helena',
    },
    dial_code: '+290',
    code: 'SH',
    flag: '🇸🇭',
  },
  {
    name: {
      en: 'Saint Kitts and Nevis',
      ru: 'Сент-Китс и Невис',
      pl: 'Saint Kitts i Nevis',
      ua: 'Сент-Кітс і Невіс',
      cz: 'Svatý Kryštof a Nevis',
      by: '',
      pt: 'São Cristóvão e Neves',
    },
    dial_code: '+1869',
    code: 'KN',
    flag: '🇰🇳',
  },
  {
    name: {
      en: 'Saint Lucia',
      ru: 'Санкт-Люсия',
      pl: 'święta Lucia',
      ua: 'Сент-Люсія',
      cz: 'Svatá Lucie',
      by: '',
      pt: 'Santa Lúcia',
    },
    dial_code: '+1758',
    code: 'LC',
    flag: '🇱🇨',
  },
  {
    name: {
      en: 'Saint Martin',
      ru: 'Сен-Мартен',
      pl: 'święty Marcin',
      ua: 'Святий Мартін',
      cz: 'Svatý Martin',
      by: '',
      pt: 'São Martinho',
    },
    dial_code: '+590',
    code: 'MF',
    flag: '🇲🇫',
  },
  {
    name: {
      en: 'Saint Pierre and Miquelon',
      ru: 'Сен-Пьер и Микелон',
      pl: 'Saint-Pierre i Miquelon',
      ua: "Сен-П'єр і Мікелон",
      cz: 'Svatý Pierre a Miquelon',
      by: '',
      pt: 'São Pedro e Miquelon',
    },
    dial_code: '+508',
    code: 'PM',
    flag: '🇵🇲',
  },
  {
    name: {
      en: 'Saint Vincent and the Grenadines',
      ru: 'Святой Винсент и Гренадины',
      pl: 'Saint Vincent i Grenadyny',
      ua: 'Сент-Вінсент і Гренадини',
      cz: 'Svatý Vincenc a Grenadiny',
      by: '',
      pt: 'São Vicente e Granadinas',
    },
    dial_code: '+1784',
    code: 'VC',
    flag: '🇻🇨',
  },
  {
    name: {
      en: 'Samoa',
      ru: 'Самоа',
      pl: 'Samoa',
      ua: 'Самоа',
      cz: 'Samoa',
      by: '',
      pt: 'Samoa',
    },
    dial_code: '+685',
    code: 'WS',
    flag: '🇼🇸',
  },
  {
    name: {
      en: 'San Marino',
      ru: 'Сан-Марино',
      pl: 'San Marino',
      ua: 'Сан-Марино',
      cz: 'San Marino',
      by: '',
      pt: 'São Marinho',
    },
    dial_code: '+378',
    code: 'SM',
    flag: '🇸🇲',
  },
  {
    name: {
      en: 'Sao Tome and Principe',
      ru: 'Сан-Томе и Принсипи',
      pl: 'Wyspy Świętego Tomasza i Książęca',
      ua: 'Сан-Томе і Принсіпі',
      cz: 'Svatý Tomáš a Princův ostrov',
      by: '',
      pt: 'São Tomé e Príncipe',
    },
    dial_code: '+239',
    code: 'ST',
    flag: '🇸🇹',
  },
  {
    name: {
      en: 'Saudi Arabia',
      ru: 'Саудовская Аравия',
      pl: 'Arabia Saudyjska',
      ua: 'Саудівська Аравія',
      cz: 'Saudská arábie',
      by: '',
      pt: 'Arábia Saudita',
    },
    dial_code: '+966',
    code: 'SA',
    flag: '🇸🇦',
  },
  {
    name: {
      en: 'Senegal',
      ru: 'Сенегал',
      pl: 'Senegal',
      ua: 'Сенегал',
      cz: 'Senegal',
      by: '',
      pt: 'Senegal',
    },
    dial_code: '+221',
    code: 'SN',
    flag: '🇸🇳',
  },
  {
    name: {
      en: 'Serbia',
      ru: 'Сербия',
      pl: 'Serbia',
      ua: 'Сербія',
      cz: 'Srbsko',
      by: '',
      pt: 'Sérvia',
    },
    dial_code: '+381',
    code: 'RS',
    flag: '🇷🇸',
  },
  {
    name: {
      en: 'Seychelles',
      ru: 'Сейшельские острова',
      pl: 'Seszele',
      ua: 'Сейшельські острови',
      cz: 'Seychely',
      by: '',
      pt: 'Seicheles',
    },
    dial_code: '+248',
    code: 'SC',
    flag: '🇸🇨',
  },
  {
    name: {
      en: 'Sierra Leone',
      ru: 'Сьерра-Леоне',
      pl: 'Sierra Leone',
      ua: 'Сьєрра-Леоне',
      cz: 'Sierra Leone',
      by: '',
      pt: 'Serra Leoa',
    },
    dial_code: '+232',
    code: 'SL',
    flag: '🇸🇱',
  },
  {
    name: {
      en: 'Singapore',
      ru: 'Сингапур',
      pl: 'Singapur',
      ua: 'Сінгапур',
      cz: 'Singapur',
      by: '',
      pt: 'Singapura',
    },
    dial_code: '+65',
    code: 'SG',
    flag: '🇸🇬',
  },
  {
    name: {
      en: 'Slovakia',
      ru: 'Словакия',
      pl: 'Słowacja',
      ua: 'Словаччина',
      cz: 'Slovensko',
      by: '',
      pt: 'Eslováquia',
    },
    dial_code: '+421',
    code: 'SK',
    flag: '🇸🇰',
  },
  {
    name: {
      en: 'Slovenia',
      ru: 'Словения',
      pl: 'Słowenia',
      ua: 'Словенія',
      cz: 'Slovinsko',
      by: '',
      pt: 'Eslovénia',
    },
    dial_code: '+386',
    code: 'SI',
    flag: '🇸🇮',
  },
  {
    name: {
      en: 'Solomon Islands',
      ru: 'Соломоновы острова',
      pl: 'Wyspy Salomona',
      ua: 'Соломонові острови',
      cz: 'Solomonovy ostrovy',
      by: '',
      pt: 'Ilhas Salomão',
    },
    dial_code: '+677',
    code: 'SB',
    flag: '🇸🇧',
  },
  {
    name: {
      en: 'Somalia',
      ru: 'Сомали',
      pl: 'Somali',
      ua: 'Сомалі',
      cz: 'Somálsko',
      by: '',
      pt: 'Somália',
    },
    dial_code: '+252',
    code: 'SO',
    flag: '🇸🇴',
  },
  {
    name: {
      en: 'South Africa',
      ru: 'Южная Африка',
      pl: 'Afryka Południowa',
      ua: 'Південна Африка',
      cz: 'Jižní Afrika',
      by: '',
      pt: 'África do Sul',
    },
    dial_code: '+27',
    code: 'ZA',
    flag: '🇿🇦',
  },
  {
    name: {
      en: 'South Georgia and the South Sandwich Islands',
      ru: 'Южная Георгия и Южные Сандвичевы острова',
      pl: 'Georgia Południowa i Sandwich Południowy',
      ua: 'Південна Джорджія та Південні Сандвічеві острови',
      cz: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
      by: '',
      pt: 'Geórgia do Sul e Sandwich do Sul',
    },
    dial_code: '+500',
    code: 'GS',
    flag: '🇬🇸',
  },
  {
    name: {
      en: 'Spain',
      ru: 'Испания',
      pl: 'Hiszpania',
      ua: 'Іспанія',
      cz: 'Španělsko',
      by: '',
      pt: 'Espanha',
    },
    dial_code: '+34',
    code: 'ES',
    flag: '🇪🇸',
  },
  {
    name: {
      en: 'Sri Lanka',
      ru: 'Шри-Ланка',
      pl: 'Sri Lanka',
      ua: 'Шрі Ланка',
      cz: 'Srí Lanka',
      by: '',
      pt: 'Sri Lanca',
    },
    dial_code: '+94',
    code: 'LK',
    flag: '🇱🇰',
  },
  {
    name: {
      en: 'Sudan',
      ru: 'Судан',
      pl: 'Sudan',
      ua: 'Судан',
      cz: 'Súdán',
      by: '',
      pt: 'Sudão',
    },
    dial_code: '+249',
    code: 'SD',
    flag: '🇸🇩',
  },
  {
    name: {
      en: 'Suriname',
      ru: 'Суринам',
      pl: 'Surinam',
      ua: 'Суринам',
      cz: 'Surinam',
      by: '',
      pt: 'Suriname',
    },
    dial_code: '+597',
    code: 'SR',
    flag: '🇸🇷',
  },
  {
    name: {
      en: 'Svalbard and Jan Mayen',
      ru: 'Шпицберген и Ян Майен',
      pl: 'Svalbard i Jan Mayen',
      ua: 'Шпіцберген та Ян Маєн',
      cz: 'Špicberky a Jan Mayen',
      by: '',
      pt: 'Svalbard e Jan Mayen',
    },
    dial_code: '+47',
    code: 'SJ',
    flag: '🇸🇯',
  },
  {
    name: {
      en: 'Swaziland',
      ru: 'Свазиленд',
      pl: 'Suazi',
      ua: 'Свазіленд',
      cz: 'Svazijsko',
      by: '',
      pt: 'Suazilândia',
    },
    dial_code: '+268',
    code: 'SZ',
    flag: '🇸🇿',
  },
  {
    name: {
      en: 'Sweden',
      ru: 'Швеция',
      pl: 'Szwecja',
      ua: 'Швеція',
      cz: 'Švédsko',
      by: '',
      pt: 'Suécia',
    },
    dial_code: '+46',
    code: 'SE',
    flag: '🇸🇪',
  },
  {
    name: {
      en: 'Switzerland',
      ru: 'Швейцария',
      pl: 'Szwajcaria',
      ua: 'Швейцарія',
      cz: 'Švýcarsko',
      by: '',
      pt: 'Suíça',
    },
    dial_code: '+41',
    code: 'CH',
    flag: '🇨🇭',
  },
  {
    name: {
      en: 'Syrian Arab Republic',
      ru: 'Сирийская Арабская Республика',
      pl: 'Republika Syryjsko-Arabska',
      ua: 'Сирійська Арабська Республіка',
      cz: 'Syrská Arabská republika',
      by: '',
      pt: 'Síria',
    },
    dial_code: '+963',
    code: 'SY',
    flag: '🇸🇾',
  },
  {
    name: {
      en: 'Taiwan, Province of China',
      ru: 'Тайвань, провинция Китая',
      pl: 'Tajwan, prowincja Chin',
      ua: 'Тайвань, провінція Китаю',
      cz: 'Tchaj-wan, provincie Číny',
      by: '',
      pt: 'Taiwan',
    },
    dial_code: '+886',
    code: 'TW',
    flag: '🇹🇼',
  },
  {
    name: {
      en: 'Tajikistan',
      ru: 'Таджикистан',
      pl: 'Tadżykistan',
      ua: 'Таджикистан',
      cz: 'Tádžikistán',
      by: '',
      pt: 'Tajiquistão',
    },
    dial_code: '+992',
    code: 'TJ',
    flag: '🇹🇯',
  },
  {
    name: {
      en: 'Tanzania, United Republic of',
      ru: 'Танзания, Объединенная Республика',
      pl: 'Tanzania, Zjednoczona Republika',
      ua: "Танзанія, Об'єднана республіка",
      cz: 'Tanzanie, Velká republika',
      by: '',
      pt: 'Tanzânia',
    },
    dial_code: '+255',
    code: 'TZ',
    flag: '🇹🇿',
  },
  {
    name: {
      en: 'Thailand',
      ru: 'Таиланд',
      pl: 'Tajlandia',
      ua: 'Таїланд',
      cz: 'Thajsko',
      by: '',
      pt: 'Tailândia',
    },
    dial_code: '+66',
    code: 'TH',
    flag: '🇹🇭',
  },
  {
    name: {
      en: 'Timor-Leste',
      ru: 'Восточный Тимор',
      pl: 'Timor Wschodni',
      ua: 'Восточний Тимор',
      cz: 'Východní Timor',
      by: '',
      pt: 'Timor Leste',
    },
    dial_code: '+670',
    code: 'TL',
    flag: '🇹🇱',
  },
  {
    name: {
      en: 'Togo',
      ru: 'Того',
      pl: 'Togo',
      ua: 'Того',
      cz: 'Togo',
      by: '',
      pt: 'Togo',
    },
    dial_code: '+228',
    code: 'TG',
    flag: '🇹🇬',
  },
  {
    name: {
      en: 'Tokelau',
      ru: 'Токелау',
      pl: 'Tokelau',
      ua: 'Токелау',
      cz: 'Tokelau',
      by: '',
      pt: 'Tokelau',
    },
    dial_code: '+690',
    code: 'TK',
    flag: '🇹🇰',
  },
  {
    name: {
      en: 'Tonga',
      ru: 'Тонга',
      pl: 'Tonga',
      ua: 'Тонга',
      cz: 'Tonga',
      by: '',
      pt: 'Tonga',
    },
    dial_code: '+676',
    code: 'TO',
    flag: '🇹🇴',
  },
  {
    name: {
      en: 'Trinidad and Tobago',
      ru: 'Тринидад и Тобаго',
      pl: 'Trynidad i Tobago',
      ua: 'Тринідад і Тобаго',
      cz: 'Trinidad a Tobago',
      by: '',
      pt: 'Trindade e Tobago',
    },
    dial_code: '+1868',
    code: 'TT',
    flag: '🇹🇹',
  },
  {
    name: {
      en: 'Tunisia',
      ru: 'Тунис',
      pl: 'Tunezja',
      ua: 'Туніс',
      cz: 'Tunisko',
      by: '',
      pt: 'Tunísia',
    },
    dial_code: '+216',
    code: 'TN',
    flag: '🇹🇳',
  },
  {
    name: {
      en: 'Turkey',
      ru: 'Турция',
      pl: 'Turcja',
      ua: 'Туреччина',
      cz: 'Turecko',
      by: '',
      pt: 'Turquia',
    },
    dial_code: '+90',
    code: 'TR',
    flag: '🇹🇷',
  },
  {
    name: {
      en: 'Turkmenistan',
      ru: 'Туркменистан',
      pl: 'Turkmenia',
      ua: 'Туркменістан',
      cz: 'Turkmenistán',
      by: '',
      pt: 'Turquemenistão',
    },
    dial_code: '+993',
    code: 'TM',
    flag: '🇹🇲',
  },
  {
    name: {
      en: 'Turks and Caicos Islands',
      ru: 'Острова Теркс и Кайкос',
      pl: 'Wyspy Turks i Caicos',
      ua: 'Острови Теркс і Кайкос',
      cz: 'ostrovy Turks a Cacois',
      by: '',
      pt: 'Ilhas Turcas e Caicos',
    },
    dial_code: '+1649',
    code: 'TC',
    flag: '🇹🇨',
  },
  {
    name: {
      en: 'Tuvalu',
      ru: 'Тувалу',
      pl: 'Tuvalu',
      ua: 'Тувалу',
      cz: 'Tuvalu',
      by: '',
      pt: 'Tuvalu',
    },
    dial_code: '+688',
    code: 'TV',
    flag: '🇹🇻',
  },
  {
    name: {
      en: 'Uganda',
      ru: 'Уганда',
      pl: 'Uganda',
      ua: 'Уганда',
      cz: 'Uganda',
      by: '',
      pt: 'Uganda',
    },
    dial_code: '+256',
    code: 'UG',
    flag: '🇺🇬',
  },
  {
    name: {
      en: 'Ukraine',
      ru: 'Украина',
      pl: 'Ukraina',
      ua: 'Україна',
      cz: 'Ukrajina',
      by: '',
      pt: 'Ucrânia',
    },
    dial_code: '+380',
    code: 'UA',
    flag: '🇺🇦',
  },
  {
    name: {
      en: 'United Arab Emirates',
      ru: 'Объединенные Арабские Эмираты',
      pl: 'Zjednoczone Emiraty Arabskie',
      ua: "Об'єднані Арабські Емірати",
      cz: 'Spojené arabské emiráty',
      by: '',
      pt: 'Emiratos Árabes Unidos',
    },
    dial_code: '+971',
    code: 'AE',
    flag: '🇦🇪',
  },
  {
    name: {
      en: 'United Kingdom',
      ru: 'Объединенное Королевство',
      pl: 'Zjednoczone Królestwo',
      ua: "Об'єднане Королівство",
      cz: 'Spojené království',
      by: '',
      pt: 'Reino Unido',
    },
    dial_code: '+44',
    code: 'GB',
    flag: '🇬🇧',
  },
  {
    name: {
      en: 'United States',
      ru: 'Соединенные Штаты',
      pl: 'Stany Zjednoczone',
      ua: 'Сполучені Штати',
      cz: 'Spojené státy',
      by: '',
      pt: 'Estados Unidos',
    },
    dial_code: '+1',
    code: 'US',
    flag: '🇺🇸',
  },
  {
    name: {
      en: 'Uruguay',
      ru: 'Уругвай',
      pl: 'Urugwaj',
      ua: 'Уругвай',
      cz: 'Uruguay',
      by: '',
      pt: 'Uruguai',
    },
    dial_code: '+598',
    code: 'UY',
    flag: '🇺🇾',
  },
  {
    name: {
      en: 'Uzbekistan',
      ru: 'Узбекистан',
      pl: 'Uzbekistan',
      ua: 'Узбекистан',
      cz: 'Uzbekistán',
      by: '',
      pt: 'Usbequistão',
    },
    dial_code: '+998',
    code: 'UZ',
    flag: '🇺🇿',
  },
  {
    name: {
      en: 'Vanuatu',
      ru: 'Вануату',
      pl: 'Vanuatu',
      ua: 'Вануату',
      cz: 'Vanuatu',
      by: '',
      pt: 'Vanuatu',
    },
    dial_code: '+678',
    code: 'VU',
    flag: '🇻🇺',
  },
  {
    name: {
      en: 'Venezuela, Bolivarian Republic of',
      ru: 'Венесуэла, Боливарианская Республика',
      pl: 'Wenezuela, Republika Boliwariańska',
      ua: 'Венесуела, Боліваріанська Республіка',
      cz: 'Venezuela, Bolívarovská republika',
      by: '',
      pt: 'Venezuela',
    },
    dial_code: '+58',
    code: 'VE',
    flag: '🇻🇪',
  },
  {
    name: {
      en: 'Viet Nam',
      ru: 'Вьетнам',
      pl: 'Wietnam',
      ua: "В'єтнам",
      cz: 'Vietnam',
      by: '',
      pt: 'Vietname',
    },
    dial_code: '+84',
    code: 'VN',
    flag: '🇻🇳',
  },
  {
    name: {
      en: 'Virgin Islands, British',
      ru: 'Виргинские острова, Британские',
      pl: 'Wyspy Dziewicze, Brytyjskie',
      ua: 'Віргінські острови, Британські',
      cz: 'Panenské ostrovy, Britové',
      by: '',
      pt: 'Ilhas Virgens Britânicas',
    },
    dial_code: '+1284',
    code: 'VG',
    flag: '🇻🇬',
  },
  {
    name: {
      en: 'Virgin Islands, U.S.',
      ru: 'Американские Виргинские острова',
      pl: 'Wyspy Dziewicze Stanów Zjednoczonych',
      ua: 'Віргінські острови, США',
      cz: 'Panenské ostrovy, USA',
      by: '',
      pt: 'Ilhas Virgens Americanas',
    },
    dial_code: '+1340',
    code: 'VI',
    flag: '🇻🇮',
  },
  {
    name: {
      en: 'Wallis and Futuna',
      ru: 'Уоллис и Футуна',
      pl: 'Wallis i Futuna',
      ua: 'Уолліс і Футуна',
      cz: 'Wallis a Futuna',
      by: '',
      pt: 'Wallis e Futuna',
    },
    dial_code: '+681',
    code: 'WF',
    flag: '🇼🇫',
  },
  {
    name: {
      en: 'Yemen',
      ru: 'Йемен',
      pl: 'Jemen',
      ua: 'Ємен',
      cz: 'Jemen',
      by: '',
      pt: 'Iémen',
    },
    dial_code: '+967',
    code: 'YE',
    flag: '🇾🇪',
  },
  {
    name: {
      en: 'Zambia',
      ru: 'Замбия',
      pl: 'Zambia',
      ua: 'Замбія',
      cz: 'Zambie',
      by: '',
      pt: 'Zâmbia',
    },
    dial_code: '+260',
    code: 'ZM',
    flag: '🇿🇲',
  },
  {
    name: {
      en: 'Zimbabwe',
      ru: 'Зимбабве',
      pl: 'Zimbabwe',
      ua: 'Зімбабве',
      cz: 'Zimbabwe',
      by: '',
      pt: 'Zimbabué',
    },
    dial_code: '+263',
    code: 'ZW',
    flag: '🇿🇼',
  },
  {
    name: {
      en: 'Åland Islands',
      ru: 'Аландские острова',
      pl: 'Wyspy Alandzkie',
      ua: 'Аландські острови',
      cz: 'Alandy',
      by: '',
      pt: 'Ilhas Aland',
    },
    dial_code: '+358',
    code: 'AX',
    flag: '🇦🇽',
  },
]
